import { SingleSelectControl } from "@dgs/core";
import { FC } from "react";
import styled from "styled-components";
import { TenantOptionResource } from "../../../../shared/types/tenant";
import { useGlobalTenants } from "../../tenants/global/GlobalTenantProvider";

const TenantSelectControl = styled(SingleSelectControl<TenantOptionResource | null, TenantOptionResource>)`
	margin: 0;
	padding: 0;
`;

export const GlobalTenantSwitcher: FC = () => {
	const { selectTenant, tenants, selected } = useGlobalTenants();

	if (!tenants.length || tenants.length === 1) {
		return null;
	}

	return (
		<TenantSelectControl
			onChange={async (e) => {
				if (e.target.value) {
					await selectTenant(e.target.value);
				}
			}}
			value={selected.tenant}
			label=""
			name="tenant"
			options={tenants}
			getLabel={(o) => o.name}
			getValue={(o) => o}
			clearable={false}
			readOnly={tenants.length === 1}
		/>
	);
};
